import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal } from "@/lib/motion";
import { FAQS } from "@/data/content";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq" className="bg-brand-cream py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-brown mb-4">FAQ</p>
            <h2 className="font-heading font-bold text-brand-ink tracking-tight text-3xl sm:text-4xl leading-[1.05]">
              Questions, answered.
            </h2>
            <p className="mt-5 text-brand-ink/65 leading-relaxed">
              Still unsure? Reach us on WhatsApp or request a free on-field demonstration.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-brand-ink/10">
                  <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-heading font-semibold text-brand-ink text-base sm:text-lg py-5 hover:no-underline hover:text-brand-green">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-brand-ink/70 leading-relaxed text-base pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
